export default __webpack_public_path__ + "static/media/image-ph-study-report-n-w@3x.41faf345.webp";